








































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Types
import { IWebhookForm } from "@/models/webhooks";

@Component
export default class WebhookAddEditForm extends Mixins(HasValidation) {
  // Props

  @Prop({ required: true })
  public value!: IWebhookForm;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Getters

  public get form() {
    return this.value;
  }

  // Setters

  public set form(value) {
    this.$emit("input", value);
  }

  // Computed

  public get showSecretField() {
    return _.has(this.form, "secret");
  }
}
